import createReducer, { ActionCreatorHelper } from 'store/createReducer';
import { InvoicePayerType } from 'store/models/invoices';
import { PayerDetail } from 'store/models/payerDetail';

type Payers = Omit<PayerDetail, 'payers' | 'dateLastUpdate' | 'activePayer'>[];
type FilterValue = string;
export type FilterPayerType = InvoicePayerType | '';
type FilterWithoutAgreement = boolean;
type InvoiceAmount = string;
type InvoiceAccountId = string;
type IsLoad = boolean;

export enum PayerFilterType {
    Empty = 'FILTER_TYPE_EMPTY',
    EmployerId = 'EMPLOYER_ID',
    HHId = 'HH_ID',
    UserId = 'USER_ID',
    AccountId = 'ACCOUNT_ID',
    Title = 'TITLE',
}

interface Account {
    id: number;
    title: string | null;
    isMain: boolean;
}

interface InvoicePayer {
    payerId: number;
    userId: number;
    userName: string;
    email: string;
    accounts: Account[];
}

interface InvoiceInfo {
    id: number;
    number: number;
    createdAt: string;
}

// ----------------------- actions -------------------------------------
const SET_IS_LOAD_PAYERS = 'SET_IS_LOAD_PAYERS';
const SET_PAYERS_PAYERS = 'SET_PAYERS_PAYERS';
const SET_FILTER_TYPE_PAYERS = 'SET_FILTER_TYPE_PAYERS';
const SET_FILTER_VALUE_PAYERS = 'SET_FILTER_VALUE_PAYERS';
const SET_FILTER_PAYER_TYPE = 'SET_FILTER_PAYER_TYPE';
const SET_FILTER_WITHOUT_AGREEMENT = 'SET_FILTER_WITHOUT_AGREEMENT';
const SET_INVOICE_PAYER_PAYERS = 'SET_INVOICE_PAYER_PAYERS';
const SET_INVOICE_AMOUNT_PAYERS = 'SET_INVOICE_AMOUNT_PAYERS';
const SET_INVOICE_ACCOUNT_ID_PAYERS = 'SET_INVOICE_ACCOUNT_ID_PAYERS';
const SET_INVOICE_INFO_PAYERS = 'SET_INVOICE_INFO_PAYERS';

interface PayloadTypes {
    [SET_IS_LOAD_PAYERS]: IsLoad;
    [SET_PAYERS_PAYERS]: Payers;
    [SET_FILTER_TYPE_PAYERS]: PayerFilterType;
    [SET_FILTER_VALUE_PAYERS]: FilterValue;
    [SET_FILTER_PAYER_TYPE]: FilterPayerType;
    [SET_FILTER_WITHOUT_AGREEMENT]: FilterWithoutAgreement;
    [SET_INVOICE_PAYER_PAYERS]: Partial<InvoicePayer>;
    [SET_INVOICE_AMOUNT_PAYERS]: InvoiceAmount;
    [SET_INVOICE_ACCOUNT_ID_PAYERS]: InvoiceAccountId;
    [SET_INVOICE_INFO_PAYERS]: Partial<InvoiceInfo>;
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const setLoadPayers = ActionCreator(SET_IS_LOAD_PAYERS);
export const setPayers = ActionCreator(SET_PAYERS_PAYERS);
export const setFilterType = ActionCreator(SET_FILTER_TYPE_PAYERS);
export const setFilterValue = ActionCreator(SET_FILTER_VALUE_PAYERS);
export const setFilterPayerType = ActionCreator(SET_FILTER_PAYER_TYPE);
export const setFilterWithoutAgreement = ActionCreator(SET_FILTER_WITHOUT_AGREEMENT);
export const setInvoicePayer = ActionCreator(SET_INVOICE_PAYER_PAYERS);
export const setInvoiceAmount = ActionCreator(SET_INVOICE_AMOUNT_PAYERS);
export const setInvoiceAccountId = ActionCreator(SET_INVOICE_ACCOUNT_ID_PAYERS);
export const setInvoiceInfo = ActionCreator(SET_INVOICE_INFO_PAYERS);
// ----------------------- /actions -------------------------------------

// ----------------------- reducer --------------------------------------
interface PayersState {
    isLoad: IsLoad;
    payers: Payers;
    filterType: PayerFilterType;
    filterValue: FilterValue;
    filterPayerType: FilterPayerType;
    filterWithoutAgreement: FilterWithoutAgreement;
    invoicePayer: Partial<InvoicePayer>;
    invoiceAmount: InvoiceAmount;
    invoiceAccountId: InvoiceAccountId;
    invoiceInfo: Partial<InvoiceInfo>;
}

const PAYERS_INITIAL_STATE: PayersState = {
    isLoad: false,
    payers: [],
    filterType: PayerFilterType.EmployerId,
    filterValue: '',
    filterPayerType: '',
    filterWithoutAgreement: false,
    invoicePayer: {},
    invoiceAmount: '',
    invoiceAccountId: '',
    invoiceInfo: {},
};

export default createReducer<PayersState, PayloadTypes>(PAYERS_INITIAL_STATE, {
    [SET_IS_LOAD_PAYERS]: (state, { payload }) => ({
        ...state,
        isLoad: payload,
    }),
    [SET_PAYERS_PAYERS]: (state, { payload }) => ({
        ...state,
        payers: payload,
    }),
    [SET_FILTER_TYPE_PAYERS]: (state, { payload }) => ({
        ...state,
        filterType: payload,
    }),
    [SET_FILTER_VALUE_PAYERS]: (state, { payload }) => ({
        ...state,
        filterValue: payload,
    }),
    [SET_FILTER_PAYER_TYPE]: (state, { payload }) => ({
        ...state,
        filterPayerType: payload,
    }),
    [SET_FILTER_WITHOUT_AGREEMENT]: (state, { payload }) => ({
        ...state,
        filterWithoutAgreement: payload,
    }),
    [SET_INVOICE_PAYER_PAYERS]: (state, { payload }) => ({
        ...state,
        invoicePayer: payload,
    }),
    [SET_INVOICE_AMOUNT_PAYERS]: (state, { payload }) => ({
        ...state,
        invoiceAmount: payload,
    }),
    [SET_INVOICE_ACCOUNT_ID_PAYERS]: (state, { payload }) => ({
        ...state,
        invoiceAccountId: payload,
    }),
    [SET_INVOICE_INFO_PAYERS]: (state, { payload }) => ({
        ...state,
        invoiceInfo: payload,
    }),
});
// ----------------------- /reducer --------------------------------------
